import { ReactElement } from 'react';

import { AlertIcon, IconFillColor, IconSize, IconWrapper, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

export const UrgentLabel = (): ReactElement => {
   return (
      <StyledFlex gap={'8px'} alignItems={'center'}>
         <IconWrapper testId={'urgent'} fillColor={IconFillColor.ERROR} size={IconSize.NORMAL}>
            <AlertIcon />
         </IconWrapper>
         <Translate>{translationKeys.urgentAppointment}</Translate>
      </StyledFlex>
   );
};
